<template lang="pug">
  .theindex.main-container
    .breadcrumbs(v-if="showBreadcrumbs")
      rogue-link.breadcrumb(to="/") {{ __('Home') }}
      span &nbsp;/&nbsp;
      rogue-link.breadcrumb(to="/theindex") {{ __('The Index') }}
      template(v-if="category && category.name !== 'Uncategorized'")
        span &nbsp;/&nbsp;
        rogue-link.breadcrumb(:to="'/theindex/' + category.slug" ) {{ __(category.name) }}
      span &nbsp;/&nbsp;
      span.breadcrumb.current-path(:class="{capitalize: !title}" v-translate v-html="title || currentPath.split('-').join(' ')")
    rogue-link.logo-link(v-if="!$rogue.isApp()" to="/theindex")
      img.logo(src='@/assets/theindex-logo.svg' alt="The Index")
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue'
import { useRoute } from 'vue-router'

type Category = {
  id: number,
  name: string,
  slug: string,
}

defineProps({
  showBreadcrumbs: {
    type    : Boolean,
    default : true,
  },
  category: {
    type    : Object as PropType<Category>,
    default : null,
  },
  title: {
    type    : String,
    default : null,
  },
})

const route = useRoute()

const currentPath = computed(() => {
  const splits = route.path.split('/')

  return splits[splits.length - 1]
})
</script>

<style lang="scss" scoped>
  .breadcrumbs {
    padding: $space-m 0;
  }

  .breadcrumb {
    font-size: $size-xs;
    color: $color-black;
    text-decoration: none;

    &:not(.current-path):hover {
      text-decoration: underline;
    }

    &.capitalize {
      text-transform: capitalize;
    }
  }

  .logo-link {
    display: block;
    text-align: center;
    margin-bottom: $space-xxl;
  }

  .logo {
    height: $size-xxxl;
  }
</style>
